module.exports = __webpack_public_path__ + "static/media/test8_1.a91207d3.png";